// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainWebsite from './MainWebsite';
import UnlockAppPage from './UnlockAppPage';
import PublicProfilePage from './PublicProfilePage';
import EmailConfirmation from './email-confirmation.js';
import ResetPassword from './reset-password.js';
import LegalPage from './LegalPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainWebsite />} />
        <Route path="/app" element={<UnlockAppPage />} />
        <Route path="/u/:username" element={<PublicProfilePage />} />
        <Route path="/profile/:username" element={<PublicProfilePage />} />
        <Route path="/terms" element={<LegalPage pageType="terms" />} />
        <Route path="/privacy" element={<LegalPage pageType="privacy" />} />
        <Route path="/email-confirmation/*" element={<EmailConfirmation />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
}

export default App;
